import React, { useState } from 'react';
import './whitelabel.scss';
import { nxtdash_fetch_api, appendFormData } from '../../apicall';
import ProNotice from '../pro-model/pro-notice'
import { __ } from '@wordpress/i18n';

const plugin_url = nxtext_ajax_object.nxtex_url || nxtext_ajax_object.tpgb_url;

const Whitelabel = () => {
    const data = nxtext_ajax_object?.dashData?.whiteLabel || {};
    const [fields, setFields] = useState({
        brand_name: data?.brand_name || '',
        theme_name: data?.theme_name || '',
        theme_desc: data?.theme_desc || '',
        author_name: data?.author_name || '',
        author_uri: data?.author_uri || '',
        theme_logo: data?.theme_logo || '',
        theme_logo_id: data?.theme_logo_id || '',
        theme_screenshot: data?.theme_screenshot || '',
        theme_screenshot_id: data?.theme_screenshot_id || '',
        nxt_free_plugin_name: data?.nxt_free_plugin_name || '',
        nxt_pro_plugin_name: data?.nxt_pro_plugin_name || '',
        nxt_free_plugin_desc: data?.nxt_free_plugin_desc || '',
        nxt_pro_plugin_desc: data?.nxt_pro_plugin_desc || '',
        tpgb_plugin_name: data?.tpgb_plugin_name || '',
        tpgb_plugin_desc: data?.tpgb_plugin_desc || '',
        tpgb_author_name: data?.tpgb_author_name || '',
        tpgb_author_uri: data?.tpgb_author_uri || '',
        tpgb_plus_logo: data?.tpgb_plus_logo || '',
        tpgb_free_plugin_name: data?.tpgb_free_plugin_name || '',
        tpgb_free_plugin_desc: data?.tpgb_free_plugin_desc || '',
        tpgb_free_author_name: data?.tpgb_free_author_name || '',
        tpgb_free_author_uri: data?.tpgb_free_author_uri || '',
        tpgb_hidden_label: data?.tpgb_hidden_label || '',
        nxt_hidden_label: data?.nxt_hidden_label || '',
        nxt_help_link : data?.nxt_help_link || 'hidden',
        nxt_plugin_news : data?.nxt_plugin_news || 'hidden',
        nxt_plugin_ads : data?.nxt_plugin_ads || 'hidden',
        nxt_template_tab : data?.nxt_template_tab || 'hidden',
        nxt_licence_tab : data?.nxt_licence_tab || 'hidden',
        nxt_rollback_tab : data?.nxt_rollback_tab || 'hidden',
        nxt_wdk_integration : data?.nxt_wdk_integration || 'hidden',
    });

    const [activeTab, setActiveTab] = useState((nxtext_ajax_object?.dashData?.tpgbinstall ? 'blocks' :  (nxtext_ajax_object?.dashData?.extensioninstall ? 'extensions' : (nxtext_ajax_object?.dashData?.nexterThemeActive ? 'theme' : 'general'))));
    const [errors, setErrors] = useState({});

    const check_box = [
        { text: __('Hide all Help Links?' , 'nexter-extension'), key: 'nxt_help_link' },
        { text: __('Hide all Plugin Updates related News?', 'nexter-extension'), key: 'nxt_plugin_news' },
        { text: __('Hide Our Recommended plugin Ads?', 'nexter-extension'), key: 'nxt_plugin_ads' },
        { text: __('Hide Starter Templates Tab?', 'nexter-extension'), key: 'nxt_template_tab' },
        { text: __('Hide Licence Key Tab?', 'nexter-extension'), key: 'nxt_licence_tab' },
        { text: __('Hide Plugin RollBack Tab?', 'nexter-extension'), key: 'nxt_rollback_tab' },
        { text: __('Hide WDesignKit Integration for Templates, Presets, Code Snippets & Cloud Storage', 'nexter-extension'), key: 'nxt_wdk_integration' },
    ];

    const validateFields = () => {
        const newErrors = {};
        const maxLengths = {
            brand_name: 50,
            theme_name: 50,
            theme_desc: 250,
            author_name: 50,
            author_uri: 50,
            nxt_free_plugin_name: 50,
            nxt_pro_plugin_name: 50,
            nxt_free_plugin_desc: 150,
            nxt_pro_plugin_desc: 150,
            tpgb_free_plugin_name: 50,
            tpgb_free_plugin_desc: 150,
            tpgb_free_author_name: 50,
            tpgb_plugin_name: 50,
            tpgb_plugin_desc: 150,
            tpgb_author_name: 50,
            tpgb_author_uri: 50,
            tpgb_free_author_uri: 50
        };
        
        const validationMessages = {
            brand_name: __('Please keep the character under 50 characters', 'nexter-extension'),
            theme_name: __('Please keep the character under 50 characters', 'nexter-extension'),
            theme_desc: __('Please keep the character under 250 characters', 'nexter-extension'),
            author_name: __('Please keep the character under 50 characters', 'nexter-extension'),
            author_uri: __('Please enter a valid URL', 'nexter-extension'),
            nxt_free_plugin_name: __('Please keep the character 50 characters', 'nexter-extension'),
            nxt_pro_plugin_name: __('Please keep the character 50 characters', 'nexter-extension'),
            nxt_free_plugin_desc: __('Please keep the character under 150 characters', 'nexter-extension'),
            nxt_pro_plugin_desc: __('Please keep the character under 150 characters', 'nexter-extension'),
            tpgb_free_plugin_name: __('Please keep the character 50 characters', 'nexter-extension'),
            tpgb_free_plugin_desc: __('Please keep the character under 150 characters', 'nexter-extension'),
            tpgb_free_author_name: __('Please keep the character under 50 characters', 'nexter-extension'),
            tpgb_plugin_name: __('Please keep the character 50 characters', 'nexter-extension'),
            tpgb_plugin_desc: __('Please keep the character under 150 characters', 'nexter-extension'),
            tpgb_author_name: __('Please keep the character under 50 characters', 'nexter-extension'),
            tpgb_author_uri: __('Please enter a valid URL', 'nexter-extension'),
            tpgb_free_author_uri: __('Please enter a valid URL', 'nexter-extension'),
        };
    
        const urlRegex = /^(https?:\/\/)?[\w\-]+(\.[\w\-]+)+[/#?]?.*$/;
    
        Object.keys(maxLengths).forEach((key) => {
            if (fields[key].length > maxLengths[key] || 
               ((key === 'author_uri' || key === 'tpgb_author_uri' || key === 'tpgb_free_author_uri') && fields[key].trim() !== '' && !urlRegex.test(fields[key]))) {
                newErrors[key] = validationMessages[key];
            }
        });
    
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false;
        }
    
        setErrors({});
        return true;
    };

    const handleFieldChange = (key, value) => {
        setFields((prevFields) => ({
                ...prevFields,
                [key]: value,
            }));
        };

    const handleUpdate = async (e) => {
        e.preventDefault();

        if (!validateFields()) return;

        e.target.innerHTML = 'Saving...';

        // Initialize variables safely
        let formData = null;
        let tpgb_form = null;
        let theme_form = null;
        let response = null;
        let tpgb_response = null;
        let theme_response = null;
        let data = null;
        let tpgb_data = null;
        let theme_data = null;

        try {
            // ---- Nexter Form Data ----
            if (nxtext_ajax_object.tpgb_pro || nxtext_ajax_object.pro) {
                formData = new FormData();
                formData.append('action', 'nexter_ext_save_data');
                formData.append('extension_type', 'white-label');
                formData.append('nexter_nonce', nxtext_ajax_object.ajax_nonce);
                formData.append('wpWLSet', JSON.stringify(fields));

                response = await nxtdash_fetch_api(formData);
                data = await response;
            }

            if (nxtext_ajax_object?.dashData?.nexterThemeActive) {
                theme_form = new FormData();
                theme_form.append('action', 'nexter_theme_white_label_save');
                theme_form.append('nexter_nonce', nxtext_ajax_object.ajax_nonce);
                theme_form.append('options', JSON.stringify(fields));

                theme_response = await nxtdash_fetch_api(theme_form);
                theme_data = await theme_response;
            }

            // ---- TPG Blocks Form Data ----
            if (nxtext_ajax_object.tpgb_pro || nxtext_ajax_object.pro) {
                tpgb_form = new FormData();
                const tpgb_formData = {
                    action: 'tpgb_white_label_save',
                    'submit-key': 'Save',
                    fields: JSON.stringify(fields),
                    nonce_tpgb_white_label: nxtext_ajax_object.ajax_nonce,
                };
                appendFormData(tpgb_form, tpgb_formData);

                tpgb_response = await nxtdash_fetch_api(tpgb_form);
                tpgb_data = await tpgb_response;
            }

            // ---- Handle Results ----
            const success =
            (data && data.success) ||
            (theme_data && (theme_data.success || theme_data.success)) ||
            (tpgb_data && (tpgb_data.success || tpgb_data.Success));

            e.target.innerHTML = success ? 'Done' : 'Save Failed';
            if (success) {
                setTimeout(() => (e.target.innerHTML = 'Save'), 1000);
                window.location.reload();
            } else {
                setTimeout(() => (e.target.innerHTML = 'Save'), 1500);
            }
        } catch (error) {
            e.target.innerHTML = 'Error';
            setTimeout(() => (e.target.innerHTML = 'Save'), 1500);
        }
    };


    /* const handleReset = async (e) => {
        e.preventDefault();
        let confirma = '';

        confirma = confirm(__('Are you sure you want to Reset this Form Data?', 'nexter-extension'));

        if (confirma) {
            let formData = new FormData();
            formData.append('action', 'nexter_white_label_reset');
            formData.append('nexter_nonce', nxtext_ajax_object.ajax_nonce);
            formData.append('submit-key', 'reset');
            try {
                const response = await nxtdash_fetch_api(formData);
                const data = await response

                if(data && data.success){
                    setFields('')
                    window.location.reload();
                }
            
            } catch (error) {
                console.error('Oops... Something Wrong', error);
            }
        }
        
    } */

    var ext_fieldArr = [
        {
            key: 'nxt_free_plugin_name',
            label: __('Plugin Name (Free Version)', 'nexter-extension'),
            field: 'text',
            placeholder: __('Enter Plugin Name', 'nexter-extension'),
        },
        {
            key: 'nxt_pro_plugin_name',
            label: __('Plugin Name (Pro Version)', 'nexter-extension'),
            field: 'text',
            placeholder: __('Enter Plugin Name', 'nexter-extension'),
        },
        {
            key: 'nxt_free_plugin_desc',
            label: __('Plugin Description (Free Version)', 'nexter-extension'),
            field: 'textarea',
            placeholder: __('Enter Plugin Description', 'nexter-extension'),
        },
        {
            key: 'nxt_pro_plugin_desc',
            label: __('Plugin Description (Pro Version)', 'nexter-extension'),
            field: 'textarea',
            placeholder: __('Enter Plugin Description', 'nexter-extension'),
        },
        {
            key: 'author_name',
            label: __('Developer / Agency', 'nexter-extension'),
            field: 'text',
            placeholder: __('Enter Developer Name', 'nexter-extension'),
        },
        {
            key: 'author_uri',
            label: __('Website URL (Pro Version)', 'nexter-extension'),
            field: 'text',
            placeholder: __('Enter Website URL', 'nexter-extension'),
        },
    ];

    var theme_fieldArr = [
        {
            key: 'theme_name',
            label: __('Theme Name', 'nexter-extension'),
            field: 'text',
            placeholder: __('Enter Theme Name', 'nexter-extension'),
        },
        {
            key: 'theme_desc',
            label: __('Theme Description', 'nexter-extension'),
            field: 'textarea',
            placeholder: __('Enter Theme Description', 'nexter-extension'),
        },
        {
            key: 'author_name',
            label: __('Developer / Agency', 'nexter-extension'),
            field: 'text',
            placeholder: __('Enter Developer Name', 'nexter-extension'),
        },
        {
            key: 'theme_screenshot',
            label: __('Theme Screenshot', 'nexter-extension'),
            field: 'file',
        },
    ];

    var general_fieldArr = [
        {
            key: 'brand_name',
            label: __('Brand Name', 'nexter-extension'),
            field: 'text',
            placeholder: __('Enter Brand Name', 'nexter-extension'),
        },
        {
            key: 'theme_logo',
            label: __('Upload Logo / Icon', 'nexter-extension'),
            field: 'file',
        },
    ];

    var blocks_fieldArr = [
        {
            key: 'tpgb_plugin_name',
            label: __('Plugin Name (Pro Version)', 'nexter-extension'),
            field: 'text',
            placeholder: __('Enter Plugin Name', 'nexter-extension'),
        },
        {
            key: 'tpgb_plugin_desc',
            label: __('Plugin Description (Pro Version)', 'nexter-extension'),
            field: 'textarea',
            placeholder: __('Enter Plugin Description', 'nexter-extension'),
        },
        {
            key: 'tpgb_author_name',
            label: __('Developer / Agency (Pro Version)', 'nexter-extension'),
            field: 'text',
            placeholder: __('Enter Developer Name', 'nexter-extension'),
        },
        {
            key: 'tpgb_author_uri',
            label: __('Website URL (Pro Version)', 'nexter-extension'),
            field: 'text',
            placeholder: __('Enter Web URL', 'nexter-extension'),
        },
        /* {
            key: 'tpgb_plus_logo',
            label: __('Upload Logo / Icon', 'nexter-extension'),
            field: 'file',
        }, */
        {
            key: 'tpgb_free_plugin_name',
            label: __('Plugin Name (Free Version)', 'nexter-extension'),
            field: 'text',
            placeholder: __('Enter Plugin Name', 'nexter-extension'),
        },
        {
            key: 'tpgb_free_plugin_desc',
            label: __('Plugin Description (Free Version)', 'nexter-extension'),
            field: 'textarea',
            placeholder: __('Enter Plugin Description', 'nexter-extension'),
        },
        {
            key: 'tpgb_free_author_name',
            label: __('Developer / Agency (Free Version)', 'nexter-extension'),
            field: 'text',
            placeholder: __('Enter Developer Name', 'nexter-extension'),
        },
        {
            key: 'tpgb_free_author_uri',
            label: __('Website URL (Free Version)', 'nexter-extension'),
            field: 'text',
            placeholder: __('Enter Website URL', 'nexter-extension'),
        },
    ];

    const openMediaUploader = (key) => {
        const frame = wp.media({
            title: __('Select or Upload Media', 'nexter-extension'),
            button: {
                text: __('Use this media', 'nexter-extension'),
            },
            multiple: false,
            library: {
                type: 'image',
            },
        });

        frame.on('select', () => {
            const attachment = frame.state().get('selection').first().toJSON();
            handleFieldChange(key, attachment.url);
            setTimeout(()=>{
                handleFieldChange(key+'_id', attachment.id);
            }, 0)
        });
        frame.open();
    };

    const nxtreImg = (key) => {
        if (fields[key]) {
            let updatedSettings = { ...fields };
            updatedSettings[key] = '';
            updatedSettings[key+'_id'] = '';
            setFields(updatedSettings); 
        }
    };    

    return (
        <div className='nxt_whitelabel_inner_main nxtext_main_container'>
            <div className='nxtext_section_heading_cover'>
                <div className='nxt-whitelabel-heading'>
                    <h3 className='nxtext_primary_heading'>{__('White Label', 'nexter-extension')}</h3>
                </div>

                <div className='nxtext_head_tgl_btn_grp'>
                    <a target="_blank" rel="noopener noreferrer"  href={'https://nexterwp.com/docs/white-label-nexter-with-your-brand-name/?utm_source=wpbackend&utm_medium=admin&utm_campaign=whitelabelpage'} className='nxtext_tertiary_btn nxtext_paragraph'>{__('Learn How it Works?', 'nexter-extension')}</a>
                    { ((nxtext_ajax_object.dashData.activePlan) || (nxtext_ajax_object.dashData.tpgb_activePlan)) &&
                        <>
                            {/* <button onClick={handleReset} className='nxtext_blue_common_btn'>{__('Reset', 'nexter-extension')}</button> */}
                            <button onClick={handleUpdate} className='nxtext_blue_common_btn'>{__('Save Settings', 'nexter-extension')}</button>
                        </>
                    }
                </div>
            </div>

            <div className="nxtext_section_heading_cover nxt_whitelabel_tab_cover">
                {nxtext_ajax_object.dashData.nexterBlock &&
                    <button
                        key={'blocks'}
                        onClick={() => setActiveTab('blocks')}
                        className={`nxt_white_label_tab_btn ${
                            activeTab === 'blocks'
                            ? "nxt_blue_common_btn"
                            : ""
                        }`}
                        >
                        {'Nexter Blocks'}
                    </button>
                }
                {nxtext_ajax_object.dashData.extensioninstall &&
                   <button
                        key={'extensions'}
                        onClick={() => setActiveTab('extensions')}
                        className={`nxt_white_label_tab_btn ${
                            activeTab === 'extensions'
                            ? "nxt_blue_common_btn"
                            : ""
                        }`}
                        >
                        {'Nexter Extensions'}
                    </button>
                }
                {nxtext_ajax_object.dashData.nexterThemeActive &&
                    <button
                        key={'theme'}
                        onClick={() => setActiveTab('theme')}
                        className={`nxt_white_label_tab_btn ${
                            activeTab === 'theme'
                            ? "nxt_blue_common_btn"
                            : ""
                        }`}
                        >
                        {'Nexter Theme'}
                    </button>
                }
                {(nxtext_ajax_object.pro || nxtext_ajax_object.tpgb_pro) &&
                    <button
                        key={'general'}
                        onClick={() => setActiveTab('general')}
                        className={`nxt_white_label_tab_btn ${
                            activeTab === 'general'
                            ? "nxt_blue_common_btn"
                            : ""
                        }`}
                        >
                        {'General'}
                    </button>
                }
            </div>
            
            {activeTab === 'blocks' &&
                <div className={'nxt_whitelabel_content_cover' + (((nxtext_ajax_object.pro && nxtext_ajax_object.tpgb_pro == undefined) || (nxtext_ajax_object.tpgb_pro == "1")) ? '' : ' nxt-whilbl-enable')}>
                <div className='nxt_field_divider_cover'>
                    {blocks_fieldArr.map((objField) => (
                        <div className='nxtext_field_card_cover' key={objField.key}>
                            { objField.field !== 'file' &&
                                <div className='nxtext_crd_head_strip'>
                                    <label className='nxtext_secondary_heading' htmlFor={objField.key}>
                                        {objField.label}
                                    </label>
                                </div>
                            }
                            {objField.field === 'text' && (
                                <div className='nxtext_field_card_bottom'>
                                    <input
                                        id={objField.key}
                                        className={"nxtext_text_field" + ( errors[objField.key] ? ' nxt_text_error' : '' )}
                                        type="text"
                                        placeholder={objField.placeholder}
                                        value={fields[objField.key]}
                                        onChange={(e) => handleFieldChange(objField.key, e.target.value)}
                                    />
                                    {errors[objField.key] && <p className="nxt_error_message">{errors[objField.key]}</p>}
                                </div>
                            )}
                            {objField.field === 'textarea' && (
                                <div className='nxtext_field_card_bottom'>
                                    <textarea
                                        rows="5"
                                        id={objField.key}
                                        className="nxtext_text_field"
                                        placeholder={objField.placeholder}
                                        value={fields[objField.key]}
                                        onChange={(e) => handleFieldChange(objField.key, e.target.value)}
                                    />
                                    {errors[objField.key] && <p className="nxt_error_message">{errors[objField.key]}</p>}
                                </div>
                            )}
                            {objField.field === 'file' && (
                                <div className={'nxt_upload_file_input_cover nxtext_text_field' + (fields[objField.key] ? ' nxt-img-select' : '')} id="nxt_plugin_logo" >
                                    <input type="file" style={{ display: 'none' }}  accept="image/png, image/jpeg, image/gif, image/webp" />
                                    { fields[objField.key] ? 
                                        <>
                                            <div className='nxt-Preview-img' style={{ backgroundImage: fields.tpgb_plus_logo ? `url(${fields.tpgb_plus_logo})` : 'none' ,backgroundSize: 'contain',backgroundPosition: 'center' , height: '300px' , backgroundRepeat : "no-repeat" }} >
                                                <div className="nxt-media-actions" onClick={()=>{nxtreImg(objField.key)}}><button className="nxt-media-remove" aria-label="Remove" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none"><path fill="#010101" fillRule="evenodd" d="M5 1.5a.5.5 0 0 0-.5.5v.5h3V2a.5.5 0 0 0-.5-.5zm3.5 1V2A1.5 1.5 0 0 0 7 .5H5A1.5 1.5 0 0 0 3.5 2v.5h-2a.5.5 0 0 0 0 1H2V10a1.5 1.5 0 0 0 1.5 1.5h5A1.5 1.5 0 0 0 10 10V3.5h.5a.5.5 0 0 0 0-1zM3 3.5V10a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 9 10V3.5zM5 5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 5 5m2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 7 5" clipRule="evenodd"/></svg></button></div>
                                            </div>
                                            <span className='nxt-Preview-img-bottom' onClick={()=>{ openMediaUploader(objField.key) }}> { __('Replace Image', 'nexter-extension') } </span>
                                        </>
                                        :
                                        <div className='nxt_upload_file_placeholder' onClick={()=>{ openMediaUploader(objField.key) }}>
                                            <img src={plugin_url + 'assets/svg/nxt_upload_placeholder.svg'} draggable={false} alt="Upload Placeholder" />
                                            <p className='nxtext_secondary_heading'>{__('Upload your Icon File', 'nexter-extension')} <br></br> {__('Only .png, .jpg .svg supported', 'nexter-extension')} </p>
                                        </div>
                                    }
                                    
                                    <input type="hidden" name="tpgb_plus_logo" id="tpgb_plus_logo" value={ fields[objField.key] }/>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                { !((nxtext_ajax_object.pro && nxtext_ajax_object.tpgb_pro == undefined && nxtext_ajax_object.dashData.activePlan) || (nxtext_ajax_object.tpgb_pro == "1" && nxtext_ajax_object?.dashData?.tpgb_activePlan)) && ( //tpgb_activePlan
                    <div className='nxt-pop-sticky'>
                        <ProNotice isPopupType={'blocks'} />
                    </div>  
                )}
            </div>
            }
            {activeTab === 'extensions' &&
                <div className={'nxt_whitelabel_content_cover' + (!nxtext_ajax_object.pro ? ' nxt-whilbl-enable' : '')}>
                    <div className='nxt_field_divider_cover'>
                        {ext_fieldArr.map((objField) => (
                            <div className={'nxtext_field_card_cover '+((objField.field == 'text' || objField.field == 'file') ? 'cover-half-width' : '')} key={objField.key}>
                                <div className='nxtext_crd_head_strip'>
                                    <label className='nxtext_secondary_heading' htmlFor={objField.key}>
                                        {objField.label}
                                    </label>
                                </div>
                                {objField.field === 'text' && (
                                    <div className='nxtext_field_card_bottom'>
                                        <input
                                            id={objField.key}
                                            className={"nxtext_text_field" + ( errors[objField.key] ? ' nxt_text_error' : '' )}
                                            type="text"
                                            placeholder={objField.placeholder}
                                            value={fields[objField.key]}
                                            onChange={(e) => handleFieldChange(objField.key, e.target.value)}
                                        />
                                        {errors[objField.key] && <p className="nxt_error_message">{errors[objField.key]}</p>}
                                    </div>
                                )}
                                {objField.field === 'textarea' && (
                                    <div className='nxtext_field_card_bottom'>
                                        <textarea
                                            rows="5"
                                            id={objField.key}
                                            className="nxtext_text_field"
                                            placeholder={objField.placeholder}
                                            value={fields[objField.key]}
                                            onChange={(e) => handleFieldChange(objField.key, e.target.value)}
                                        />
                                        {errors[objField.key] && <p className="nxt_error_message">{errors[objField.key]}</p>}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    
                    { (!nxtext_ajax_object.dashData.activePlan ) && (
                        <div className='nxt-pop-sticky'>
                            <ProNotice />
                        </div>  
                    )}
                </div>
            }

            {activeTab === 'theme' &&
                <div className={'nxt_whitelabel_content_cover' + (!nxtext_ajax_object.pro && !nxtext_ajax_object.tpgb_pro ? ' nxt-whilbl-enable' : '')}>
                    <div className='nxt_field_divider_cover'>
                        {theme_fieldArr.map((objField) => (
                            <div className={'nxtext_field_card_cover'} key={objField.key}>
                                <div className='nxtext_crd_head_strip'>
                                    <label className='nxtext_secondary_heading' htmlFor={objField.key}>
                                        {objField.label}
                                    </label>
                                </div>
                                {objField.field === 'text' && (
                                    <div className='nxtext_field_card_bottom'>
                                        <input
                                            id={objField.key}
                                            className={"nxtext_text_field" + ( errors[objField.key] ? ' nxt_text_error' : '' )}
                                            type="text"
                                            placeholder={objField.placeholder}
                                            value={fields[objField.key]}
                                            onChange={(e) => handleFieldChange(objField.key, e.target.value)}
                                        />
                                        {errors[objField.key] && <p className="nxt_error_message">{errors[objField.key]}</p>}
                                    </div>
                                )}
                                {objField.field === 'textarea' && (
                                    <div className='nxtext_field_card_bottom'>
                                        <textarea
                                            rows="5"
                                            id={objField.key}
                                            className="nxtext_text_field"
                                            placeholder={objField.placeholder}
                                            value={fields[objField.key]}
                                            onChange={(e) => handleFieldChange(objField.key, e.target.value)}
                                        />
                                        {errors[objField.key] && <p className="nxt_error_message">{errors[objField.key]}</p>}
                                    </div>
                                )}
                                {objField.field === 'file' && (
                                    <div className={'nxt_upload_file_input_cover nxtext_text_field' + (fields[objField.key] ? ' nxt-img-select' : '')} id="nxt_plugin_logo" >
                                        <input type="file" style={{ display: 'none' }}  accept="image/png, image/jpeg, image/gif, image/webp" />
                                        { fields[objField.key] ? 
                                            <>
                                                <div className='nxt-Preview-img' style={{ backgroundImage: fields[objField.key] ? `url(${fields[objField.key]})` : 'none' ,backgroundSize: 'contain',backgroundPosition: 'center' , height: '300px' , backgroundRepeat : "no-repeat" }} >
                                                    <div className="nxt-media-actions" onClick={()=>{nxtreImg(objField.key)}} ><button className="nxt-media-remove" aria-label="Remove" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none"><path fill="#010101" d="M5 1.5a.5.5 0 0 0-.5.5v.5h3V2a.5.5 0 0 0-.5-.5zm3.5 1V2A1.5 1.5 0 0 0 7 .5H5A1.5 1.5 0 0 0 3.5 2v.5h-2a.5.5 0 0 0 0 1H2V10a1.5 1.5 0 0 0 1.5 1.5h5A1.5 1.5 0 0 0 10 10V3.5h.5a.5.5 0 0 0 0-1zM3 3.5V10a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 9 10V3.5zM5 5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 5 5m2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 7 5"/></svg></button></div>
                                                </div>
                                                <span className='nxt-Preview-img-bottom' onClick={()=>{ openMediaUploader(objField.key) }}> { __('Replace Image', 'nexter-extension') } </span>
                                            </>
                                            :
                                            <div className='nxt_upload_file_placeholder' onClick={()=>{ openMediaUploader(objField.key) }}>
                                                <img src={plugin_url + 'assets/svg/nxt_upload_placeholder.svg'} draggable={false} alt="Upload Placeholder" />
                                                <p className='nxtext_secondary_heading'>{__('Drag and drop to upload your super awesome', 'nexter-extension')}<br />{__('icon/logo', 'nexter-extension')}</p>
                                            </div>
                                        }
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    
                    { (!nxtext_ajax_object.dashData.activePlan && !nxtext_ajax_object?.dashData?.tpgb_activePlan) && (
                        <div className='nxt-pop-sticky'>
                            <ProNotice />
                        </div>  
                    )}
                </div>
            }
            {activeTab === 'general' &&
                <div className={'nxt_whitelabel_content_cover' + (!nxtext_ajax_object.pro && !nxtext_ajax_object.tpgb_pro ? ' nxt-whilbl-enable' : '')}>
                    <div className='nxt_field_divider_cover'>
                        {general_fieldArr.map((objField) => (
                            <div className={'nxtext_field_card_cover'} key={objField.key}>
                                <div className='nxtext_crd_head_strip'>
                                    <label className='nxtext_secondary_heading' htmlFor={objField.key}>
                                        {objField.label}
                                    </label>
                                </div>
                                {objField.field === 'text' && (
                                    <div className='nxtext_field_card_bottom'>
                                        <input
                                            id={objField.key}
                                            className={"nxtext_text_field" + ( errors[objField.key] ? ' nxt_text_error' : '' )}
                                            type="text"
                                            placeholder={objField.placeholder}
                                            value={fields[objField.key]}
                                            onChange={(e) => handleFieldChange(objField.key, e.target.value)}
                                        />
                                        {errors[objField.key] && <p className="nxt_error_message">{errors[objField.key]}</p>}
                                    </div>
                                )}
                                {objField.field === 'textarea' && (
                                    <div className='nxtext_field_card_bottom'>
                                        <textarea
                                            rows="5"
                                            id={objField.key}
                                            className="nxtext_text_field"
                                            placeholder={objField.placeholder}
                                            value={fields[objField.key]}
                                            onChange={(e) => handleFieldChange(objField.key, e.target.value)}
                                        />
                                        {errors[objField.key] && <p className="nxt_error_message">{errors[objField.key]}</p>}
                                    </div>
                                )}
                                {objField.field === 'file' && (
                                    <div className={'nxt_upload_file_input_cover nxtext_text_field' + (fields[objField.key] ? ' nxt-img-select' : '')} id="nxt_plugin_logo" >
                                        <input type="file" style={{ display: 'none' }}  accept="image/png, image/jpeg, image/gif, image/webp" />
                                        { fields[objField.key] ? 
                                            <>
                                                <div className='nxt-Preview-img' style={{ backgroundImage: fields[objField.key] ? `url(${fields[objField.key]})` : 'none' ,backgroundSize: 'contain',backgroundPosition: 'center' , height: '300px' , backgroundRepeat : "no-repeat" }} >
                                                    <div className="nxt-media-actions" onClick={()=>{nxtreImg(objField.key)}} ><button className="nxt-media-remove" aria-label="Remove" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none"><path fill="#010101" d="M5 1.5a.5.5 0 0 0-.5.5v.5h3V2a.5.5 0 0 0-.5-.5zm3.5 1V2A1.5 1.5 0 0 0 7 .5H5A1.5 1.5 0 0 0 3.5 2v.5h-2a.5.5 0 0 0 0 1H2V10a1.5 1.5 0 0 0 1.5 1.5h5A1.5 1.5 0 0 0 10 10V3.5h.5a.5.5 0 0 0 0-1zM3 3.5V10a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 9 10V3.5zM5 5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 5 5m2 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3A.5.5 0 0 1 7 5"/></svg></button></div>
                                                </div>
                                                <span className='nxt-Preview-img-bottom' onClick={()=>{ openMediaUploader(objField.key) }}> { __('Replace Image', 'nexter-extension') } </span>
                                            </>
                                            :
                                            <div className='nxt_upload_file_placeholder' onClick={()=>{ openMediaUploader(objField.key) }}>
                                                <img src={plugin_url + 'assets/svg/nxt_upload_placeholder.svg'} draggable={false} alt="Upload Placeholder" />
                                                <p className='nxtext_secondary_heading'>{__('Drag and drop to upload your super awesome', 'nexter-extension')}<br />{__('icon/logo', 'nexter-extension')}</p>
                                            </div>
                                        }
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    
                    {check_box.length > 0 &&
                        check_box.map((ck_box, index) => {
                            return (  <div className='nxt_check_box' key={index}>
                                    <input 
                                        type="checkbox" 
                                        id={ck_box.key}
                                        className='nxt_enable_option_checkbox' 
                                        checked={ fields?.[ck_box.key] && fields?.[ck_box.key] == 'on' ? true : false }
                                        onChange={(e) => handleFieldChange( ck_box.key, e.target.checked ? 'on' : 'hidden' )}
                                        value={'on'}
                                    />
                                    <label className='nxt_checkbox_label' htmlFor={ck_box.key}>{ck_box.text}</label>
                                </div>
                            );

                        })
                    }

                    <div className='nxt_check_box'>
                        <input type="checkbox" id="nxt_hidden_label" className='nxt_enable_option_checkbox' checked={(fields?.nxt_hidden_label == 'on' || fields.tpgb_hidden_label) ? true: false}  onChange={(e) => {
                            if(e.target.checked){
                                handleFieldChange('nxt_hidden_label', 'on')
                                handleFieldChange('tpgb_hidden_label', 'on')
                            }else{
                                handleFieldChange('nxt_hidden_label', '')
                                handleFieldChange('tpgb_hidden_label', '')
                            }
                        }
                        } value={'on'} />
                        <label className='nxt_checkbox_label' htmlFor="nxt_hidden_label">
                            <b style={{ fontSize: 13 }}>{__('Enable Force Disable Options : ', 'nexter-extension')}</b>
                            {__('If you enable this option, It will be completely hidden. If you want it back, You have to deactivate and activate the plugin to make it work again.', 'nexter-extension')}
                        </label>
                    </div>
                    
                    { (!nxtext_ajax_object.dashData.activePlan && !nxtext_ajax_object?.dashData?.tpgb_activePlan) && (
                        <div className='nxt-pop-sticky'>
                            <ProNotice />
                        </div>  
                    )}
                </div>
            }
            
        </div>
    );
};

export default Whitelabel;